/**
 * API pública — endpoints do portal do munícipe.
 * Todos os endpoints são POST (mesmo os de consulta) porque CPF e token
 * anti-robô não devem trafegar em querystring/logs de acesso.
 */

import type {
  CreateResponse,
  PublicOrderRequestCreateInput,
  TrackByCPFInput,
  TrackByCPFResponse,
  TrackByProtocolInput,
  TrackByProtocolResponse,
} from '../types/publicRequest';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

/** Erro de API que pode carregar dados extras retornados pelo backend (ex: protocolNumber em conflitos). */
export class ApiError extends Error {
  status: number;
  protocolNumber?: string;

  constructor(message: string, status: number, protocolNumber?: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.protocolNumber = protocolNumber;
  }
}

async function post<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  let data: any;
  try {
    data = await res.json();
  } catch {
    throw new ApiError(`Erro inesperado do servidor (${res.status})`, res.status);
  }

  if (!res.ok) {
    throw new ApiError(data?.error || `Erro inesperado (${res.status})`, res.status, data?.protocolNumber);
  }

  return data as T;
}

export const publicRequestService = {
  create(body: PublicOrderRequestCreateInput): Promise<CreateResponse> {
    return post<CreateResponse>('/public/order-requests', body);
  },

  trackByProtocol(body: TrackByProtocolInput): Promise<TrackByProtocolResponse> {
    return post<TrackByProtocolResponse>(
      '/public/order-requests/track-by-protocol',
      body,
    );
  },

  trackByCPF(body: TrackByCPFInput): Promise<TrackByCPFResponse> {
    return post<TrackByCPFResponse>(
      '/public/order-requests/track-by-cpf',
      body,
    );
  },
};
